import React from "react";
import { useTheme } from "@/lib/ThemeContext";
import { Label } from "@/components/ui/label";
import MobileSelect from "@/components/drill/MobileSelect";

const THEME_OPTIONS = [
  { value: "system", label: "System" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];

export default function ThemeSection() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4 dark:bg-slate-900 dark:border-slate-800">
      <div>
        <h3 className="font-semibold text-slate-900 dark:text-slate-100">Appearance</h3>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Choose how DrillLog looks. System follows your device settings.
        </p>
      </div>
      <div className="space-y-2">
        <Label>Theme</Label>
        <MobileSelect
          value={theme}
          onValueChange={setTheme}
          options={THEME_OPTIONS}
          placeholder="Theme"
          className="w-full sm:w-56"
        />
      </div>
    </div>
  );
}